module.exports = __webpack_public_path__ + "static/owner-4e97becaf32d18c9b73ac7581bf021a4.png";